import React, { Fragment, useState } from 'react';

import { Formik, Field, FieldArray } from 'formik';
import * as Yup from 'yup';

import ApiClientItemRevokeSecretModal from './ApiClientItemRevokeSecretModal';
import ApiClientItemShowSecretModal from './ApiClientItemShowSecretModal';

import { urlRegMatch } from 'Helpers/urlService';

import { EyeIcon } from 'CommonComponents/icons';

const AppConfigsSchema = Yup.object().shape({
    id: Yup.string().required($t('This value is required')),
    secret_generated_at: Yup.string().nullable(),
    second_secret_generated_at: Yup.string().nullable(),
    redirects: Yup.array().of(
        Yup.string()
            .required($t('This value is required'))
            .matches(urlRegMatch, $t('App Url must be a valid URL'))
            .min(2, $t('The name must contain at least 2 characters'))
            .max(191, $t('The name must be no more than 191 characters')),
    ),
});

const SHOW_CLIENT_SECRET_MODAL_ID = 'api-client-secret-modal';
const REVOKE_CLIENT_SECRET_MODAL_ID = 'revoke-secret-modal';

export default function ApiClientItemConfigs(props) {
    const [request, setRequest] = useState(false);
    const [showId, setShowId] = useState(false);
    const [generatedSecret, setGeneratedSecret] = useState(null);
    const [revokedType, setRevokedType] = useState(null);

    const copyToClipboard = (value) => {
        navigator.clipboard.writeText(value);
    };

    const showCreateModal = () => {
        $(`#${SHOW_CLIENT_SECRET_MODAL_ID}`).modal('show');
    };

    const showRevokeModal = (type) => {
        setRevokedType(type);
        $(`#${REVOKE_CLIENT_SECRET_MODAL_ID}`).modal('show');
    };

    const closeModal = () => {
        setGeneratedSecret(null);
        setRevokedType(null);
        $(`#${SHOW_CLIENT_SECRET_MODAL_ID}`).modal('hide');
        $(`#${REVOKE_CLIENT_SECRET_MODAL_ID}`).modal('hide');
    };

    const successHandler = () => {
        closeModal();
        props.fetchApp();
    };

    const generateSecret = () => {
        setRequest(true);
        axios
            .put(props.generateSecretUrl, {})
            .then((res) => {
                setGeneratedSecret(res.data.secret);
                showCreateModal();
            })
            .catch((e) => {
                console.log(e?.response);
            })
            .finally(() => {
                setRequest(false);
            });
    };

    return (
        <div>
            <div className="table__card">
                <div className="tw-mb-6">
                    <Formik
                        enableReinitialize
                        initialValues={{
                            id: props?.app?.id || '',
                            redirects: props?.app?.redirects || [],
                            secret_generated_at: props?.app?.secret_generated_at || '',
                            second_secret_generated_at: props?.app?.second_secret_generated_at || '',
                        }}
                        validationSchema={AppConfigsSchema}
                        onSubmit={(values, actions) => {
                            axios
                                .put(props.updateConfigsUrl, values)
                                .then((res) => {})
                                .catch((e) => {
                                    console.log(e?.response);
                                    props.fetchApp();
                                })
                                .finally(() => {
                                    actions.setSubmitting(false);
                                });
                        }}
                    >
                        {({ values, errors, touched, isSubmitting, handleSubmit }) => {
                            return (
                                <>
                                    <FieldArray
                                        name="redirects"
                                        render={(arrayHelpers) => (
                                            <div>
                                                {values.redirects && values.redirects.length > 0 ? (
                                                    values.redirects.map((redirect, index) => (
                                                        <Fragment key={index}>
                                                            <div className="tw-flex tw-flex-row tw-my-3">
                                                                <label className="tw-basis-3/12 tw-font-bold" style={{ fontSize: '14px' }}>
                                                                    {$t('Redirect Url')} {index + 1} <span className="text-danger">*</span>
                                                                </label>
                                                                <div className="tw-basis-7/12">
                                                                    <Field
                                                                        type="text"
                                                                        className={
                                                                            errors.redirects &&
                                                                            errors.redirects[index] &&
                                                                            ((touched.redirect && touched.redirect[index]) ||
                                                                                (touched.redirects && touched.redirects[index]))
                                                                                ? 'input text-input invalid'
                                                                                : 'input text-input'
                                                                        }
                                                                        name={`redirects.${index}`}
                                                                        placeholder={$t('URL')}
                                                                    />
                                                                </div>
                                                                <div className="tw-basis-2/12 tw-flex tw-justify-startt">
                                                                    {values.redirects.length < (props?.app?.max_redirects_number || 5) && (
                                                                        <button
                                                                            type="button"
                                                                            className="button primary tw-ml-3 tw-mr-2"
                                                                            onClick={() => arrayHelpers.push('')}
                                                                        >
                                                                            <i className="fa fa-plus" aria-hidden="true" />
                                                                        </button>
                                                                    )}
                                                                    <button type="button" className="button danger" onClick={() => arrayHelpers.remove(index)}>
                                                                        <i className="fa fa-minus" aria-hidden="true" />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            {errors.redirects && errors.redirects[index] && touched.redirect && touched.redirect[index] && (
                                                                <div className="tw-text-red-500">{errors.redirects[index]}</div>
                                                            )}
                                                        </Fragment>
                                                    ))
                                                ) : (
                                                    <button type="button" className="button primary tw-mx-2" onClick={() => arrayHelpers.push('')}>
                                                        {$t('Add a Redirect Url')}
                                                    </button>
                                                )}

                                                <div className="tw-flex tw-flex-row tw-my-3">
                                                    <label htmlFor="name" className="tw-basis-3/12 tw-font-bold" style={{ fontSize: '14px' }}>
                                                        {$t('App Id')} <span className="tw-text-red-500">*</span>
                                                    </label>
                                                    <div className="tw-basis-7/12 tw-relative">
                                                        <Field
                                                            type={showId ? 'text' : 'password'}
                                                            className={errors.id && touched.id ? 'input text-input invalid' : 'input text-input'}
                                                            placeholder={$t('App Id')}
                                                            name="id"
                                                            disabled={true}
                                                        />
                                                        <span
                                                            className="tw-absolute tw-cursor-pointer"
                                                            style={{ top: '35%', right: '1%' }}
                                                            onClick={(e) => setShowId(!showId)}
                                                        >
                                                            <EyeIcon className="tw-w-3 tw-h-3" />
                                                        </span>
                                                        {errors.id && touched.id && <div className="tw-text-red-500">{errors.id}</div>}
                                                    </div>
                                                    <div className="tw-basis-2/12">
                                                        <button type="button" className={'button primary tw-mx-3'} onClick={(e) => copyToClipboard(values.id)}>
                                                            <i className="fa-solid fa-copy"></i>
                                                        </button>
                                                    </div>
                                                </div>

                                                <hr className="tw-my-2" />

                                                {!!props.app && props.app.has_secret && (
                                                    <div className="tw-flex tw-flex-row tw-my-3">
                                                        <label className="tw-basis-3/12 tw-font-bold" style={{ fontSize: '14px' }}>
                                                            {$t('App Secret')}
                                                        </label>
                                                        <div className="tw-basis-7/12">
                                                            <Field
                                                                type={'text'}
                                                                className={'input text-input'}
                                                                placeholder={$t('App Secret')}
                                                                name="secret_generated_at"
                                                                disabled={true}
                                                            />
                                                        </div>
                                                        <div className="tw-basis-2/12">
                                                            <button
                                                                type="button"
                                                                className={'button primary tw-mx-3'}
                                                                onClick={(e) => showRevokeModal('secret')}
                                                            >
                                                                {$t('Revoke Secret')}
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}

                                                {!!props.app && props.app.has_second_secret && (
                                                    <div className="tw-flex tw-flex-row tw-my-3">
                                                        <label className="tw-basis-3/12 tw-font-bold" style={{ fontSize: '14px' }}>
                                                            {$t('App Secret')}
                                                        </label>
                                                        <div className="tw-basis-7/12">
                                                            <Field
                                                                type={'text'}
                                                                className={'input text-input'}
                                                                placeholder={$t('App Secret')}
                                                                name="second_secret_generated_at"
                                                                disabled={true}
                                                            />
                                                        </div>
                                                        <div className="tw-basis-2/12">
                                                            <button
                                                                type="button"
                                                                className={'button primary tw-mx-3'}
                                                                onClick={(e) => showRevokeModal('second_secret')}
                                                            >
                                                                {$t('Revoke Secret')}
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}

                                                {!!props.app && (!props.app.has_secrets || !props.app.has_all_secrets) && (
                                                    <div className="tw-flex tw-flex-row tw-justify-center tw-my-3">
                                                        <button
                                                            type="button"
                                                            className={'button primary'}
                                                            disabled={!!isSubmitting || request}
                                                            onClick={generateSecret}
                                                        >
                                                            {$t('Generate Secret')}
                                                        </button>
                                                    </div>
                                                )}

                                                <div className="tw-flex tw-justify-end tw-mt-5">
                                                    <button
                                                        type="button"
                                                        className={'button primary'}
                                                        disabled={!!isSubmitting || request}
                                                        onClick={handleSubmit}
                                                    >
                                                        {$t('Submit')}
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    />
                                </>
                            );
                        }}
                    </Formik>
                </div>
            </div>
            <ApiClientItemShowSecretModal onClose={successHandler} secret={generatedSecret} />
            <ApiClientItemRevokeSecretModal
                closeHandler={closeModal}
                successHandler={successHandler}
                type={revokedType}
                revokeSecretUrl={props.revokeSecretUrl}
            />
        </div>
    );
}
